<template>
  <b-container fluid>
    <b-container>
      <b-row class="mt-3">
        <b-col xl="9" lg="8" md="7" sm="12">
          <div class="shadow border border-1 rounded  p-4">
            <h5>آدرس تحویل سفارش</h5>
            <p class="address">آدرس فعلی</p>
            <form-group :validations="$v.selectedAddress">
              <div slot-scope="{ errors, invalid }">
                <div class="user">
                  <b-icon icon="person" class="icon" /><span class="name">{{
                    currentAddress
                  }}</span>
                  <form-errors-manager :errors="errors"/>
                </div>
                <router-link class="text-primary text-decoration-none" :to="{ name: 'Delivery' }">
                  <span class="text-primary text-decoration-none" @click="ShowSelect = !ShowSelect">
                    تغییر یا انتخاب آدرس
                  </span>
                  <b-icon icon="chevron-left" />
                </router-link>

                <div class="mt-3" v-if="ShowSelect">
                  <b-form-select
                      v-model="selectedAddress"
                      :options="options"
                      :class="{ invalid }"
                  ></b-form-select>
                </div>

                <div class="my-3">
                  <router-link :to="{ name: 'CreateAddress' }">
                    <b-button pill variant="primary">اضافه کردن آدرس جدید</b-button>
                  </router-link>
                </div>
              </div>
            </form-group>
          </div>

          <b-container>
            <FreeCities :cities="freeCities"/>
          </b-container>

          <div>
            <form-group :validations="$v.textArea">
              <div slot-scope="{ errors, invalid }">
                <b-form-textarea
                    id="textarea"
                    v-model="textArea"
                    placeholder="توضیحات"
                    rows="3"
                    max-rows="3"
                    :class="{ invalid }"
                ></b-form-textarea>
                <form-errors-manager :errors="errors" />
              </div>
            </form-group>
          </div>
          <div class="my-3">
            <router-link :to="{ name: 'ShoppingCart' }">
              <b-button variant="outline-dark"
              >بازگشت به صفحه قبل
                <b-icon icon="chevron-left" />
              </b-button>
            </router-link>
          </div>
        </b-col>

        <b-col class="side-bar " xl="3" lg="4" md="5" sm="12">
          <shopping-card-sidebar
              :items="items"
              :sidebarData="sidebarData"
              :delivery-boundary="deliveryBoundary"
              :delivery-price="deliveryPrice"
              :submit="onSubmit"
              :caption="sideBarContinueText"
          />
          <div><span class="attention">حداقل خرید برای ارسال رایگان </span>
            <span class="attention">{{ formatNumber(deliveryBoundary) }}</span></div>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import { formatNumber } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import ShoppingCardSidebar from "../ShoppingCards/ShoppingCard1/Sidebar";
import { required, maxLength } from "vuelidate/lib/validators";
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup.vue";
import FormErrorsManager from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue";
import FreeCities from "../ShoppingCards/ShoppingCard1/FreeCities";

export default {
  name: "Deliver1",
  components: { ShoppingCardSidebar, FormGroup, FormErrorsManager, FreeCities },
  props: {
    sideBarContinueText: {
      default: "ادامه فرایند خرید"
    }
  },
  data() {
    return {
      ShowSelect: false,
      selectedAddress: null,
      defaultTextArea: "",
    };
  },
  validations: {
    selectedAddress: { required },
    textArea: { maxLength: maxLength(255) },
  },
  methods: {
    formatNumber,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        let form = {
          order: this.sidebarData.id,
          address_id: this.selectedAddress,
          description: this.textArea,
        };
        this.$store.dispatch("ShoppingCart/chooseAddressAndDescription", form);
      }
    },
  },
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getUserOrderUnpaidItems",
      sidebarData: "ShoppingCart/getSidebarBasketData",
      Addresses: "Address/getAddresses",
      deliveryBoundary: "ShoppingCart/getDeliveryBoundary",
      deliveryPrice: "ShoppingCart/getDeliveryPrice",
      freeCities: "ShoppingCart/getFreeCities",
    }),
    options() {
      let arr = [];
      this.Addresses.forEach((element, key) => {
        arr.push({ value: element.id, text: element.address });
      });
      return arr;
    },
    currentAddress() {
      let current = "";
      for (let i in this.Addresses) {
        if (this.selectedAddress !== null) {
          if (this.Addresses[i].id == this.selectedAddress) {
            current = this.Addresses[i].address;
          }
        }
      }
      return current;
    },
    textArea:{
      get(){
        return this.defaultTextArea
      },
      set(value){
        this.defaultTextArea = value
      }
    }
  },
  async mounted() {
    this.$store.dispatch("Address/getOrderAddresses");
    await this.$store.dispatch("ShoppingCart/userOrderUnpaid").then(res =>{
      if(res.address !== null){
        this.selectedAddress=res.address.id
      }
      this.textArea=res.description
    })
  },
};
</script>


<style scoped>

.user .icon {
  color: var(--dark);
  font-size: 18pt;
  font-weight: bold;
}

.user .name {
  margin-right: 4px;
  font-size: 11pt;
  font-weight: bold;
}

.attention{
  font-size: 12px;
}
.side-bar{
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>